import { Component, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ClaimVehicle } from '../claim-vehicle';
import { Subscription } from 'rxjs';
import { ClaimRequest } from '../claim-request';
import { FormValidation } from '../../../shared/form-validation';

@Component({
  selector: 'claim-customer',
  templateUrl: './claim-customer.component.html',
})
export class ClaimCustomerComponent implements OnInit, OnDestroy {

  public claimCustomerForm: UntypedFormGroup;
  public claim: ClaimRequest;
  public claimVehicle: ClaimVehicle;
  public claimServiceSubscription: Subscription;
  public formCompleted: boolean = false;

  constructor() { }

  ngOnInit(): void {
    this.populateData();
  }

  ngOnDestroy(): void {
    if (this.claimServiceSubscription) {
      this.claimServiceSubscription.unsubscribe();
    }
  }
  public populateData() {
    this.claimCustomerForm = new UntypedFormGroup({
      'customerFirstName': new UntypedFormControl(),
      'customerLastName': new UntypedFormControl(),
      'contractNumber': new UntypedFormControl("", [Validators.required]),
      'vin': new UntypedFormControl("", [Validators.required, Validators.pattern(/^[A-Za-z0-9]{6}$/)]),
      'breakdownDate': new UntypedFormControl("", [Validators.required]),
    });
  }
  //** Validates the customer form and sets formCompleted to valid or invalid */
  public validateForm(): void {
    this.formCompleted = FormValidation.isValid(this.claimCustomerForm);
  }
}
